import { createApiSlice } from "@common/common-slice/commonSlice";

import { CRUD_COMPETENCY_FRAMEWORK_STATUS } from "@routes";

const apiConfig = [
  {
    name: "createCompetencyFrameworkStatus",
    method: "post",
    url: CRUD_COMPETENCY_FRAMEWORK_STATUS,
    stateKey: "message",
  },
  {
    name: "getCompetencyFrameworkStatus",
    method: "get",
    url: CRUD_COMPETENCY_FRAMEWORK_STATUS,
    stateKey: "competencyFrameworkStatusData",
  },
  {
    name: "updateCompetencyFrameworkStatus",
    method: "put",
    url: CRUD_COMPETENCY_FRAMEWORK_STATUS,
    stateKey: "message",
  },
  {
    name: "deleteCompetencyFrameworkStatus",
    method: "delete",
    url: CRUD_COMPETENCY_FRAMEWORK_STATUS,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    competencyFrameworkStatusData: [],
    selectedData: {},
  },

  reducers: {
    rowSelect: (state, action) => {
      state.selectedData =
        action?.payload?.length > 0 ? action.payload[0] : {};
    },
  },

  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "competencyFrameworkStatus",
  apiConfig,
  customReducers
);

const competencyFrameworkStatusSlice = slice;
export default competencyFrameworkStatusSlice.reducer;

export const {
  createCompetencyFrameworkStatus,
  getCompetencyFrameworkStatus,
  updateCompetencyFrameworkStatus,
  deleteCompetencyFrameworkStatus,
} = thunks;

export const {
  rowSelect,
} = actions;